import type { InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
}

export const Input = ({ label, className = '', ...props }: InputProps) => (
  <div className={`flex flex-col gap-1 ${className}`}>
    {label && <label className="text-sm text-gray-400">{label}</label>}
    <input
      {...props}
      className="bg-gray-700 border border-gray-600 rounded px-3 py-2 text-white text-sm focus:outline-none focus:border-blue-500"
    />
  </div>
);
